import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import { pushGtmValues } from "@bappweb/utils"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import Notes from "./notes"
import SssList from "./ssslist"
import { useAppDispatch } from "../../../config/hook"
import { setSessionData } from "../../../state/sessionData"
import { useGetConfigListMutation } from "../../../api/services"
import { getCidParameter, getConfigValue, isNullOrEmpty, SMPUConfigListResponse } from "@smpu-web/utils/utils"

const Landing = () => {
    const dispatch = useAppDispatch()
    const [configList, setConfigList] = useState<SMPUConfigListResponse[]>()
    const [faqText, setFaqText] = useState<any[]>([]);

    const [getConfigList] = useGetConfigListMutation();
    useEffect(() => {
        getConfigList({
            functionCode: "CRC0004",
            cid: getCidParameter() ?? "",
            TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        })
            .unwrap()
            .then((payload) => {
                if (!payload.IsError) {
                    dispatch(
                        setSessionData({
                            configList: payload.configList
                        })
                    )

                    setConfigList(payload.configList)

                    if (!isNullOrEmpty(getConfigValue(payload.configList, "TKKLead.Landing.Faq"))) {
                        setFaqText(JSON.parse(getConfigValue(payload.configList, "TKKLead.Landing.Faq")))
                    }
                }
            })

        pushGtmValues({
            event: "virtual_page_view",
            content_group: "ticari-kredi-karti-lead",
            pageName: 'basvuru/ticarikredikartilead/0/landing',
            pageTitle: 'Ticari Kredi Karti Lead Başvurusu'
        })
    }, []);

    return (
        <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
            <LandingHeader configValue={getConfigValue(configList, "TicariKrediKartiLead.CampaignText.Landing.Top")} />
            <Grid type="main" className="landing-page-main">
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <MainForm />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <Notes configValue={getConfigValue(configList, "TicariKrediKartiLead.CampaignText.Landing.Bottom")} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        {faqText && <SssList faqText={faqText} />}
                    </Col>
                </Row>
            </Grid>
        </Block>
    )
}

export default Landing
